import React from 'react';
import {decodeEntities} from '@wordpress/html-entities';
import DOMPurify from "dompurify";
import {  AliasPopup, CheckoutButton } from '.';
import { Popup } from './popup';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const { getSetting } = window.wc.wcSettings

const settings = getSetting( 'spgw_postfinancepay_data', {} );

const { title, alias_manager, save_card_html, icon, description, popupTextTrans, saveCardSelectionErrorMsg } = settings;
const label = decodeEntities( settings.title || '' );
const alias = ( alias_manager == 'active' );
const desc =  DOMPurify.sanitize(description);
const cleanHTML = DOMPurify.sanitize(save_card_html);

let saveCardSelection = false;

const ContentComponent = (props) => {
	const { eventRegistration, emitResponse } = props;
	const { onPaymentSetup } = eventRegistration;
	return <div><div dangerouslySetInnerHTML={{ __html: desc }} /><Popup popupTextTrans={popupTextTrans} /><CheckoutButton />
	<AliasPopup onPaymentSetup={onPaymentSetup} emitResponse={emitResponse} saveCardSelection={saveCardSelection} saveCardSelectionErrorMsg={saveCardSelectionErrorMsg} />
	<div dangerouslySetInnerHTML={{ __html: cleanHTML }} /></div>;
  };
const Icon = () => {
	return icon 
		? <img alt='' src={icon} style={{ float: 'right', marginRight: '20px' }} /> 
		: '';
};
const Label = () => {
	return (
		<span style={{ width: '100%' }}>
			{title}
			<Icon />
		</span>
	);
};


registerPaymentMethod( {
	name: "spgw_postfinancepay",
	label: <Label />,
	content: <ContentComponent/>,
	edit: <ContentComponent />,
	canMakePayment: (props) => {
		props.cart.cartItems.forEach((cartItem, index) => {
			if(cartItem.type == "subscription") {
				saveCardSelection = true;
			}
		});
		if(props.paymentRequirements.includes("subscriptions")) {
			saveCardSelection = true;
		}
		if(!settings.availability) {
			return false;
		}
		if(props.billingAddress.country == "" || (settings.allowedCountries.length == 1 && settings.allowedCountries.includes('select'))) {
			return true;
		}
		if(settings.allowedCountries.length != 0) {
			return settings.allowedCountries.includes(props.billingAddress.country);
		}
		return true;
	},
	ariaLabel: label,
	supports: {
		features: settings.supports,
		showSavedCards: alias,
		showSaveOption: false,

	}
} )

